import { render, staticRenderFns } from "./roleModal.vue?vue&type=template&id=18c7fc79&"
import script from "./roleModal.vue?vue&type=script&lang=ts&"
export * from "./roleModal.vue?vue&type=script&lang=ts&"
import style0 from "./roleModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports